<template lang="pug">
v-layout.px-3(column)
  v-subheader.pl-1.mt-3.pb-3.font-weight-medium {{ $tf("drawer.process.apply") }}

  v-container.pa-0(fluid grid-list-md)
    v-layout(row wrap)
      v-flex(d-flex sm4 md3 v-for='(d, index) in startableDefinitions' :key="d.key" v-if="d.key === 'NEWS-01' || d.key === 'BMA-01' || d.key === 'BMA-03' || d.key === 'BMA-04' || d.key === 'BMA-05' || d.key === 'BMA-06' || (d.key === 'BMA-02' && !isZhairemRegion) || ((d.key === 'USER-01' || d.key === 'USER-02' || d.key === 'USER-03' || d.key === 'SYSTEM-01' || d.key === 'SYSTEM-02' || d.key === 'SYSTEM-03' || d.key === 'NOTIFY-01') && isCamundaAdmin)")
        v-card.semitrans(dark hover @click="selectDefinition(d)" ripple)
          v-card-title.title {{ $tf(`${d.key}._process.name`, d.name) }}
          v-card-text
      v-flex(d-flex sm4 md3 v-if="isBma0305Starters && (isRidderRegion || isUKRegion)")
        v-card.semitrans(dark hover ripple @click="select" :to="{name:'Activity'}")
          v-card-title.title {{ $tf("forms.subscriptionToPool") }}
          v-card-text
      v-flex(d-flex sm4 md3 v-if="isBma0305Starters && isRidderRegion")
        v-card.semitrans(dark hover ripple @click="select" :to="{name:'Ski'}")
          v-card-title.title {{ $tf("forms.subscriptionToSki") }}
          v-card-text
  v-subheader.pl-1.mt-3.pb-3.font-weight-medium(ripple="" @click="openNews()") {{ $tf("drawer.news.title") }}
  v-layout(column)
    wf-news
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HomeCard from '@/components/home/HomeCard'
import HomeNews from '@/components/home/News'
import ProcessInfo from '@/components/process/ProcessInfo'
import lodash from 'lodash'

export default {
  name: 'Home',

  components: {
    'wf-home-card': HomeCard,
    'wf-news': HomeNews,
    'wf-process-info': ProcessInfo,
  },

  data() {
    return {
      processDefinitionKey: null,
      loading: {
        _0: false,
        _1: false,
        _2: false,
        _3: false,
        _4: false,
        _5: false,
        _6: false,
        _7: false,
        _8: false,
        _9: false,
      },
      isAltayRegion: false,
      isUKRegion: false,
      isRidderRegion: false,
      isZhairemRegion: false
    }    
  },

  computed: {
    ...mapGetters({
      startableDefinitions: 'process/startableDefinitions',
      news: 'task/news',
      allDefinitions: 'process/allDefinitions',
      processes: 'process/processes',
      total: 'process/total',
      page: 'process/page',
      processInfoDialog: 'process/processInfoDialog',
      profile: 'auth/profile',
      groups: 'auth/groups',
    }),
    length() {
      return Math.ceil((this.total / this.page.per))
    },
    employees(){
      return this.$store.getters['data/employees'];
    },
    isBma0305Starters() {
      return lodash.some(this.groups, group => group.id == 'bma_03_06_starters');
    },
    isCamundaAdmin() {
      return lodash.some(this.groups, group => group.id == 'camunda-admin');
    }
  },
  watch: {
    'page.current'(newValue) {
      this.paginateProcesses({ newPageNumber: newValue, searchCriteria: this.getPayload(), reset: false })
    },
  },

  created() {
    this.getDefinitions(),
    this.getNews()
    this._search({ searchCriteria: this.getPayload(), reset: true })
    this.searchEmloyee(this.profile.userName);
  },

  methods: {
    ...mapActions({
      getDefinitions: 'process/getDefinitions',
      getNews: 'task/getNews',
      _search: 'process/search',
      paginateProcesses: 'process/paginateProcesses',
      toggleProcessInfoDialog: 'process/toggleProcessInfoDialog',
    }),
    selectDefinition(d) {
      this.$router.push({ name: 'ProcessStartController', params: { definitionId: d.id } })
    },

    format_date(value) { // 2022-07-18T15:40:56.994Z
      if (value) {
        return this.$moment(value).format('DD.MM.YYYY HH:mm')
      }
    },
    getTitle(processes) {
      const titleBusinessKey = processes.businessKey ? `- ${processes.businessKey}` : ''
      return `${processes.processDefinitionName} ${titleBusinessKey}`
    },
    getRange(process) {
      return `${this.$moment(process.startTime).format('DD.MM.YYYY HH:mm')} - ${process.endTime ? `${this.$moment(process.endTime).format('DD.MM.YYYY HH:mm')}` : '___.___._____ __:__'}`
    },
    getPayload() {
      let payload = { startedBy: this.profile.userName }
      if (this.processDefinitionKey) {
        payload = { ...payload, processDefinitionKey: this.processDefinitionKey }
      }
      return payload
    },

    search() {
      this._search({ searchCriteria: this.getPayload(), reset: true })
    },

    selectProcess(processId) {
      this.$refs.processInfo.show(processId)
    },

    openNews() {
      this.$router.push('/news-list')
    },

    searchEmloyee(iin){
      return this.$store.dispatch('data/getUser', iin)
    },

    select() {
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.toggleDrawer()
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.processInfoDialog) {
      this.toggleProcessInfoDialog(false)
      next(false)
    } else {
      next(true)
    }
  }, watch: {
    'employees'(employees) {
      if(this.employees.length > 0){
        if(this.employees[0].data){
          let data = this.employees[0].data;
          if(data.region){
            this.isAltayRegion = (data.region.id === 'altay');
            this.isUKRegion = (data.region.id === 'oskemen');
            this.isRidderRegion = (data.region.id === 'ridder') || (this.profile.userName === '830501301242');
            this.isZhairemRegion = (data.region.id === 'zhairem');
            this.isKokshetauRegion = (data.region.id === 'kokshetau');
          }
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.semitrans
  background-color #ff6f00bb !important
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue